import { render, staticRenderFns } from "./c-trayectoria.vue?vue&type=template&id=bb78dc2c&scoped=true&"
import script from "./c-trayectoria.vue?vue&type=script&lang=js&"
export * from "./c-trayectoria.vue?vue&type=script&lang=js&"
import style0 from "./c-trayectoria.vue?vue&type=style&index=0&id=bb78dc2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb78dc2c",
  null
  
)

export default component.exports